/** Generates all indexes of the occurences of a substring in a string, searching backwards. */
export function* lastIndexesOf(
  haystack: string,
  needle: string,
  startIndex = haystack.length,
): Iterable<number> {
  let currentIndex = startIndex;

  while (currentIndex >= 0) {
    const foundIndex = haystack.lastIndexOf(needle, currentIndex);

    if (foundIndex === -1) {
      currentIndex = -1;
    } else {
      yield foundIndex;
      currentIndex = foundIndex - 1;
    }
  }

  return currentIndex;
}
